'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Chevron = require('./Chevron');

var _Chevron2 = _interopRequireDefault(_Chevron);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Chevron2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/Chevron/index.js
// module id = 91
// module chunks = 0